import { Link, LinkProps } from "react-router-dom";
import { FC } from "react";
import styles from "./NavLink.module.scss";

export const NavLink: FC<LinkProps> = ({ children, ...props }) => (
  <Link {...props} className={styles.link}>
    {children}
  </Link>
);
